import Api from './Api';
import Configuracao from '../util/Configuracao';

class ArquivoXMLApi extends Api {
  async validarArquivo (file) {
    const validarArquivoUrl = Configuracao.getConfiguracao().urlValidarArquivo;
    const result = await this.fetch(validarArquivoUrl, 'post', file);
    return result;
  }
  async auditarArquivo (file) {
    const auditarArquivoUrl = Configuracao.getConfiguracao().urlAuditarArquivo;
    const result = await this.fetch(auditarArquivoUrl, 'post', file);
    return result;
  }
  async consultarParametrosEnvio () {
    try {
      const urlConsultarParametrosEnvio = Configuracao.getConfiguracao().urlConsultarParametrosEnvio;
      const response = await this.fetch(urlConsultarParametrosEnvio, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  async enviarArquivo (file) {
    const enviarArquivoUrl = Configuracao.getConfiguracao().enviarArquivoUrl;
    const result = await this.fetch(enviarArquivoUrl, 'post', file);
    return result;
  }
  async consultarProtocolo (codProtocolo) {
    try {
      const urlConsultarProtocolo = Configuracao.getConfiguracao().urlConsultarProtocolo + codProtocolo;
      const response = await this.fetch(urlConsultarProtocolo, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  async listarProtocolos (filter) {
    try {
      const urlListarProtocolos = Configuracao.getConfiguracao().urlListarProtocolos + filter.numProtocolo + '/seqPrestador/' + filter.seqPrestador + '/nome/' + filter.nomePrestador + '/data_inicio/' + filter.dataInicio + '/data_fim/' + filter.dataFim;
      const response = await this.fetch(urlListarProtocolos, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
  async abrirXml (txtObjetoGed) {
    try {
      const urlAbrirXml = Configuracao.getConfiguracao().urlAbrirXml + txtObjetoGed;
      const response = await this.fetch(urlAbrirXml, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }
}
export default ArquivoXMLApi;
